import { clsx } from "clsx";
import React from "react";
import Styles from "./MenuItem.module.css";

type MenuItemProps = {
  icon: string;
  label: string;
  onClick: () => void;
  title?: string;
  testId?: string;
};

const MenuItem = ({ icon, label, onClick, title, testId }: MenuItemProps) => (
  <div title={title ?? label}>
    <button
      aria-label={title ?? label}
      className={Styles.menuItem}
      data-test-id={testId}
      onClick={onClick}
      type="button"
    >
      <div className={clsx(Styles.icon, icon)} />
      <span className={Styles.label}>{label}</span>
    </button>
  </div>
);

export default MenuItem;
